import React, { useRef } from 'react';
import { MdOutlineEmail } from 'react-icons/md';
import { BsLinkedin } from 'react-icons/bs';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './contact.css';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_xw7fjlh', 'template_yz7abc4', form.current, 'FebdLgMRGk4WHgvKJ')
      .then((result) => {
        console.log(result.text);
        toast.success('Message sent successfully!');
      }, (error) => {
        console.error('EmailJS Error:', error);
        toast.error('Failed to send message. Please try again later.');
      });

    e.target.reset();
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact_container'>
        <div className='contact_options'>
          <article className="contact_option">
            <MdOutlineEmail className='contact-icon' />
            <h4>Email</h4>
            <a href='mailto:mnathu98@gmail.com' target='_blank' rel="noreferrer">Send a Message</a>
          </article>
          <article className="contact_option">
            <BsLinkedin className='contact-icon' />
            <h4>Linkedin</h4>
            <a href='https://www.linkedin.com/in/mnathuw/' target='_blank' rel="noreferrer">Send a Message</a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type='text' name='name' placeholder='Your Full Name' required />
          <input type='email' name='email' placeholder='Your Email' required />
          <textarea name='message' rows='7' placeholder='Your Message'></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
    </section>
  );
};

export default Contact;
